/** 中文文案 */
export default {
  common: {
    companyShort: '广东环海运通国际物流有限公司',
    companyEn: 'GUANGDONG HUAN SHIPPING INTERNATIONAL LOGISTICS CO.,LTD',
    titleSuffix: '广东环海运通国际物流有限公司'
  },
  nav: {
    home: '首页',
    transport: '运输业务',
    route: '航线优势',
    about: '关于我们',
    contact: '联系我们',
    language: '语言',
    zh: '简体中文',
    en: 'English',
    water: '水上运输',
    road: '公路运输',
    rail: '铁路运输',
    air: '航空运输',
    sea: '东南亚航线',
    india: '印巴航线',
    med: '地中海航线',
    caribbean: '加勒比航线',
    black: '黑海线',
    red: '红海线',
    middle: '中东线',
    us: '美线',
    europe: '欧洲线'
  },
  home: {
    nameBlue: '广东环海运通',
    nameDark: '国际物流公司',
    slogan: '—— 中国物流行业龙头企业',
    transportName: '运输',
    transportNameBlue: '业务',
    transportCopy1: '广东环海运通国际物流有限公司运输提供多种运输方式，您可以根据实际情况及价格等因素选择。',
    transportCopy2: '运输范围布及全中国，以及海外国家的主要城市。',
    aboutTitle: '关于我们',
    aboutEn: 'ABOUT US',
    aboutParagraphs: [
      '广东环海运通国际物流有限公司是国家对外贸易经济合作部正式批准的国际物流企业，专注东南亚，印巴，中东，红海，非洲，美国，欧洲航线。一直秉承诚信为本、责任担当、使命必达的经验理念，始终把客户的利益放在首位，不断完善服务内容，为国内外客户提供优质的服务。',
      '我司拥有一批专业化、高素质的员工,全程操作系统跟单服务。由销售部、市场部、操作部、财务部、行政人事部组成，目前公司在职人员一百八十余人。为您优化全套供应链，负责和船公司及时沟通，了解最新运价及动态，做好报价工作，同时熟悉海运进出口业务流程，提供订舱支持，协调与船公司、场站，目的港之间的关系，处理各方面关于操作事宜，保证各项工作有序开展。为控制您的物流成本，提高您的物流效率。'
    ],
    feature1Title: '全球供应链解决方案',
    feature1Desc: '网络遍布全球各地，全国、全球大中小城市都可以通达。',
    feature2Title: '24小时技术支持',
    feature2Desc: '有较强竞争力的专业化运营团队，我们24小时技术支持',
    feature3Title: '移动货物跟踪',
    feature3Desc: '我们提供的智能概念的道路和复杂的特殊运输服务',
    partnersCn: '合作伙伴 —',
    partnersEm: '船公司'
  },
  about: {
    name: '广东环海运通',
    nameBlue: '简介',
    intro: [
      '广东环海运通国际物流有限公司成立于 2018 年 8 月 31 日，注册资本 1000 万元，总部位于深圳龙华。公司现有员工 200 余人，是一家资质齐全、规模成熟的综合性国际物流服务商。 公司拥有国际货运代理、无船承运人双重资质，为 WCA 世界货运联盟认证会员，会员编号：136910。',
      '团队汇聚大批外贸物流行业资深从业人员，执行标准化全链路作业流程，依托完善的海内外合作网络，在全球市场树立了良好口碑。'
    ],
    cultureTitle: '公司文化',
    culture: [
      '积极 • 迅速扩展和进步的业务',
      '创新 • 持续创新和完善的服务',
      '务实 • 保持稳健中提升的作风',
      '活力•营造迅捷和亲切的体验'
    ],
    tenetName: '服务',
    tenetBlue: '宗旨',
    tenets: [
      '• 我们致力于为员工提供一份满意和值得自豪的工作',
      '• 我们致力于快速、安全、准确地传递客户的信任',
      '• 我们致力于成为货运行业持续领先的公司',
      '• 我们致力于承担更多的社会责任'
    ],
    card1Title: '全球供应链解决方案',
    card1Text: '网络遍布全球各地，全国、全球大中小城市都可以通达。',
    card2Title: '24小时技术支持',
    card2Text: '有较强竞争力的专业化运营团队，我们24小时技术支持',
    card3Title: '移动货物跟踪',
    card3Text: '我们提供的智能概念的道路和复杂的特殊运输服务'
  },
  contact: {
    name: '联系',
    nameBlue: '我们',
    phone: '电话：0755-21010347',
    address: '地址：深圳市龙华区民治大道222号东边商业大厦3楼309',
    email: 'Email：admin@ht-cargo-shipping.com',
    mapCompany: '广东环海运通国际物流有限公司',
    mapAddress: '深圳市龙华区民治大道222号东边商业大厦3楼309'
  },
  footer: {
    address: '深圳市龙华区民治大道222号东边商业大厦 3楼 309'
  },
  guest: {
    title: '请您留言',
    subtitle: '我们会尽快与您联系',
    content: '请输入留言信息（必填）',
    name: '请输入您的姓名',
    phone: '请输入您的电话（必填）',
    email: '请输入您的邮箱',
    address: '请输入您的地址',
    submit: '提交',
    submitting: '提交中…',
    submitted: '已提交',
    tipPhone: '电话：0755-21010347',
    tipService: '24小时全天恭候垂询',
    tipTop: '顶部',
    tipCall: '电话',
    tipSvc: '留言',
    warnContent: '请输入留言信息',
    warnPhone: '请输入您的电话',
    success: '留言已提交，我们会尽快与您联系',
    fail: '提交失败，请稍后重试',
    network: '网络异常，请稍后重试'
  },
  transport: {
    waterName: '水上运输',
    waterP1: '水上运输包括内河运输和海洋运输，以其历史悠久而有交通运输“祖先”之称。18世纪曾在交通运输业生产中占主要地位。水运具有投资少、成本低、货运量大、占地少等优点，好的航道通过能力几乎可不受限制， 通用性好，可作为大型、笨重和大宗长途货运的主要承担者。内河航运建设与防洪、排涝、灌溉、发电、渔业、旅游等统筹规划，可收到综合开发利用自然资源之效。但水运受自然条件影响大，如有些内河航道和海港由于冬季结冰而只能停航，有些内河航道的走向往往与运输的经济要求不一致，有些内河航道水位洪枯变化大，影响了航运利益的发挥。当前，综合运输已成为世界交通运输发展的大趋势，现代化综合运输网的建设，为充分发挥水运优势创造了条件。',
    roadName: '公路运输',
    roadP1: '公路运输是在公路上运送旅客和货物的运输方式。是交通运输系统的组成部分之一。主要承担短途客货运输。现代所用运输工具主要是汽车。因此，公路运输一般即指汽车运输。在地势崎岖、人烟稀少、铁路和水运不发达的边远和经济落后地区，公路为主要运输方式，起着运输干线作用。',
    railName: '铁路运输',
    railP1: '铁路运输，乃一种陆上运输方式，以两条平行的铁轨引导火车。铁路运输是其中一种最有效的已知陆上交通方式。铁轨能提供极光滑及坚硬的媒介让火车的车轮在上面以最小的摩擦力滚动。这样，在火车上面的人会感到更舒适，而且节省能量。如果配置得当，铁路运输可以比路面运输运载同一重量客货物时节省五至七成能量。而且，铁轨能平均分散火车的重量，令火车的载重力大大提高。',
    airName: '航空运输',
    airP1: '航空输运，是使用飞机直升机及其他航空器运送人员、货物、邮件的一种运输方式。具有快速、机动的特点，是现代旅客运输，尤其是远程旅客运输的重要方式，为国际贸易中的贵重物品、鲜活货物和精密仪器运输所不可缺。',
    airP2: '航空运输具有商品性，服务性，国际性，准军事性，资金、技术及风险密集性和自然垄断性六大特点。航空运输按照不同的标准可以分为不同的类型。航空运输起源于1871年，由于近两年国际经济低迷使得航空运输产业遭遇瓶颈，但是在未来航空运输事业依然有广阔的发展空间值得我们发掘。'
  },
  route: {
    pageTitle: '航线优势',
    seaName: '东南亚航线',
    seaP1: '东南亚线指东南亚国家的港口航线。东南亚地区共有11个国家：越南、老挝、柬埔寨、泰国、缅甸、马来西亚、新加坡、印度尼西亚、文莱、菲律宾、东帝汶。东南亚地区是亚洲纬度最低的地区，是亚洲赤道的一部分。也是太平洋与印度洋的交汇地带。东南亚航线特点是船期较多，航程较短，海运费通常不高，但是要注意一些航线的附加费。',
    seaP2: '东南亚线的主要港口有：HONG KONG（香港）、BELAWAN（勿拉湾）、SURABAYA （泗水）、PENANG （槟城）、PORT KELANG （巴生港）、CEBU （宿务）、SINGAPORE（新加坡）、HAIPHONG（ 海防）、 HOCHIMINH （胡志明市）、MANILA（ 马尼拉）、JAKARTA （雅加达）。',
    indiaName: '印巴航线',
    indiaP1: '印巴线特指从孟加拉湾至阿拉伯海的沿线国家港口航线，主要国家有印度和巴基斯坦。也包括马尔代夫、斯里兰卡以及孟加拉国。',
    indiaP2: '印巴线的主要港口有：BOMBAY（孟买）、CALCUTTA （加尔各答）、COCHIN （科钦）、COLOMBO （科伦坡）、MADRAS（马德拉斯）、KARACHI（卡拉奇）、NHAVA SHEVA （那瓦西瓦）、CHENNAI （钦奈）、NEW DELHI （新德里）。',
    medName: '地中海航线',
    medP1: '地中海航线在航运上一般被划分为地中海西部和地中海东部，也简称为地西线和地东线。地中海在交通和战略上均占有重要地位。它西经直布罗陀海峡可通大西洋，东北经土耳其海峡接黑海，东南经苏伊士运河出红海达印度洋，是欧亚非三洲之间的重要航道，也是沟通大西洋、印度洋间的重要通道。沿岸重要海港有马赛（法）、热那亚、那不勒斯（意）、斯普利特、里耶卡（克罗地亚）、都拉斯（阿尔巴尼亚）、阿尔及尔（阿尔及利亚）、塞得港（埃及）等。',
    medP2: '地西主要港口：西班牙：VALENCIA（瓦伦西亚）、BARCELONA（巴塞罗那），意大利：GENOVA（热那亚）、NAPLES（那不勒斯）、LA SPEZIA（拉斯佩齐亚），法国：FOS（福斯）',
    medP3: '地中海东部主要港口有：希腊：PIRAEUS（比雷埃夫斯）、THESSALONIKI（塞萨洛尼基），埃及：ALEXANDRIA（亚历山大）、DAMIETTA（达米埃塔），PORT SAID（塞得港），土耳其ISTANBUL（伊斯坦布尔）、IZMIR（伊兹密尔）、MERSIN（梅尔辛）、GEMLIK（盖姆利克），塞浦路斯：LIMASSOL（利马索尔），黎巴嫩：BEIRUT（贝鲁特 ），叙利亚：LATTAKIA（拉塔基亚），',
    medP4: '以色列：ASHDOD（阿什杜德）、HAIFA（海法）。',
    caribbeanName: '加勒比航线',
    caribbeanP1: '加勒比航线分布于中美洲，中美洲又包括古巴、多米尼加、多米尼加共和国、海地、牙买加、巴巴多斯、安提瓜和巴布达、阿鲁巴、巴哈马、英属维尔京群岛、开曼群岛、格林纳达、瓜得罗普、马提尼克、蒙特塞拉特、荷属安的列斯群岛、圣基茨和尼维斯、圣卢西亚、波多黎各、圣文森特和格林纳丁斯群岛、特立尼达和多巴哥、特克斯和凯科斯群岛以及美属维尔京群岛。',
    caribbeanP2: '加勒比航线的主要港口有：KINGSTON（金斯敦）、CARTAGENA （卡塔赫纳），CAUCEDO （考赛多），Port of Spain （西班牙港）、PORT AU PRINCE（太子港）、POINT LISAS （利萨斯）。这里有些国家地区地理位置属于南美东，但是航线划分维加勒比，有委内瑞拉：PUERTO CABELLO（卡贝略）、LA GUAIRA（拉瓜伊拉）、GUANTA（关塔）、MARACAIBO（马拉开波）、GUARANAO（古阿兰奥）；苏里南：PARAMARIBO（帕拉马里博）； 圭亚那：GEORGETOWN （乔治敦）。',
    blackName: '黑海线',
    blackP1: '黑海线指的是黑海沿岸港口航线，东西最长1150千米，南北最宽911千米，中部最窄263千米，海岸线长约3400千米。黑海是欧洲东南部和亚洲小亚细亚半岛之间的内海。是世界上最大的内陆海，因水色深暗、多风暴而得名。黑海向西通过博斯普鲁斯海峡、马尔马拉海、达达尼尔海峡与地中海相通，向北经刻赤海峡与亚速海相连。黑海北岸为乌克兰，东北岸为俄罗斯，格鲁吉亚在其东岸，土耳其在南岸，保加利亚、罗马尼亚和摩尔多瓦(Moldova)在其西岸。黑海是联系乌克兰、保加利亚、罗马尼亚、俄罗斯西南部与世界市场的航运要道。',
    blackP2: '黑海线的主要港口有：乌克兰：ODESSA（敖德萨），罗马利亚：CONSTANTZA（康斯坦萨）、格鲁吉亚：POTI（波季），保加利亚：BURGAS（布尔加斯）、VARNA（瓦尔纳），俄罗斯：NOVOROSSIYSK（新罗西斯克）。',
    redName: '红海线',
    redP1: '红海线位于非洲东北部和阿拉伯半岛之间的狭长海域。面积约450,000平方公里(174,000平方哩)。红海由埃及苏伊士向东南延伸到曼德海峡，长约2100公里。曼德海峡连接亚丁湾，然后通往阿拉伯海。红海最宽处为306公里(190哩)。红海线西岸的埃及、苏丹、衣索比亚和东岸的沙特阿拉伯、也门隔海相对。在北端，红海分成两部分：西北部为水浅的苏伊士湾，东北部为水深的亚喀巴湾。',
    redP2: '红海线的主要港口有：AQABA （亚喀巴）、JEDDAH （吉达）、PORT SUDAN（苏丹港）、HODEIDAH（荷台达）、SOKHNA （苏科纳）。',
    middleName: '中东线',
    middleP1: '中东线是指地中海东部与南部区域，从地中海东部到波斯湾的大片地区，中东从地理上也是非洲东北部与亚洲大陆西南部的地区。中东线包括的国家有巴林、 埃及、 伊朗、伊拉克、以色列、约旦、科威特、黎巴嫩、阿曼、卡塔尔、 沙特、叙利亚、阿联酋和也门，巴勒斯坦等等。我们日常所说的“中东”并不是正式的地理术语，而是因为其历史文化原因让我们认为巴林、伊朗、伊拉克、以色列、约旦、科威特、黎巴嫩、阿曼、卡塔尔、沙特、叙利亚、阿联酋和也门是中东地区。埃及、索马里、苏丹地理位置上属非洲但部分港口属中东地区的红海区域。而土耳其和塞浦路斯尽管地理上属于中东地区，但是他们自认为属于欧洲。',
    middleP2: '中东线的主要港口有：ABU DHABI （阿布扎比）、DUBAI（迪拜）、UMM QASAR （乌姆盖斯尔）、BANDAR ABBAS （阿巴斯港）、KUWAIT（ 科威特）、SALALAH （塞拉莱）、DOHA （多哈）、DAMMAN（ 达曼）、 RIYADH（利雅得）。',
    usName: '美线',
    usP1: '美线主要港口按地理位置分为美东（指美国东海岸）以及美西（指美国西海岸）两部分。美国美东的主要港口（也称为基本港）有：纽约（NEWYORK）、萨凡纳（SAVANNAH）、迈阿密（MIAMI）、诺福克（NORFOLK）、杰克逊维尔（JACKSONVILLE）、查尔斯顿（CHARLESTON）；',
    usP2: '美国美西的主要港口（也称为基本港）有：洛杉矶（LOSANGELES）、长滩（LONGBEACH）、西雅图（SEATTLE,WA）、奥克兰（OAKLAND）。',
    europeName: '欧洲线',
    europeP1: '欧洲位于东半球的西北部，亚洲的西面。北临北冰洋，西濒大西洋，南隔地中海与非洲相望，东以乌拉尔山脉，乌拉尔河，大高加索山脉，博斯普鲁斯海峡,达达尼尔海峡同亚洲分界，西北隔格陵兰海，丹麦海峡与北美洲相对。',
    europeP2: '欧洲主要港口：弗利克斯托（FELIXSTOWE）， 汉堡（HAMBURG），安特卫普（ANTWERP） 鹿特丹（ROTTERDAM），勒阿佛尔（LE HAVRE） ，不来梅（BREMEN） ，南安普顿（SOUTHAMPTON），泽布昌赫（ZEEBRUGGE），泰晤士港（THAMESPORT），不来梅哈芬（BREMERHAVEN） 其中：FELIXSTOWE 弗利克斯托 英国，HAMBURG汉堡德国，ANTWERP 安特卫普比利时ROTTERDAM 鹿特丹荷兰，LE HAVER 勒阿佛尔法国。这五个港口通常被称为欧洲基本港，也叫欧基港。'
  }
}
